<script>
export default {
    name: "Authorize",
    created() {
        if(this.$route.query.hash) {
            localStorage.setItem('hash', this.$route.query.hash)
        }
        this.$router.push(this.$route?.query?.return_url || '/')
    }
}
</script>

<template>

</template>

<style scoped>

</style>